// @ts-nocheck
/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-unused-vars, prettier/prettier */
import * as Types from './generated/types';

import { gql } from '@apollo/client';
import { PaymentFieldsFragmentDoc } from './payments.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type PaymentBlockFieldsFragment = { __typename?: 'PaymentBlock', id: string, title: string, subtitle?: string | null, subtitle2?: string | null, payment_gateway: Types.PaymentGateway, type?: Types.PaymentBlockType | null, brand?: string | null, is_default?: boolean | null };

export type StripeSetupIntentFieldsFragment = { __typename?: 'StripeSetupIntent', id: string, client_secret: string };

export type StripePaymentIntentFieldsFragment = { __typename?: 'StripePaymentIntent', id: string, client_secret: string };

export type SportsmanPaymentBlocksQueryVariables = Types.Exact<{
  sportsmanId: Types.Scalars['ID']['input'];
}>;


export type SportsmanPaymentBlocksQuery = { __typename?: 'Query', sportsmanPaymentBlocks: Array<{ __typename?: 'PaymentBlock', id: string, title: string, subtitle?: string | null, subtitle2?: string | null, payment_gateway: Types.PaymentGateway, type?: Types.PaymentBlockType | null, brand?: string | null, is_default?: boolean | null }> };

export type GroupPayMemberPaymentBlocksQueryVariables = Types.Exact<{
  groupPayMemberId: Types.Scalars['ID']['input'];
}>;


export type GroupPayMemberPaymentBlocksQuery = { __typename?: 'Query', groupPayMemberPaymentBlocks: Array<{ __typename?: 'PaymentBlock', id: string, title: string, subtitle?: string | null, subtitle2?: string | null, payment_gateway: Types.PaymentGateway, type?: Types.PaymentBlockType | null, brand?: string | null, is_default?: boolean | null }> };

export type StripeAccountInfoQueryVariables = Types.Exact<{
  onboardLinkUrls: Types.AccountOnboardLinkInput;
}>;


export type StripeAccountInfoQuery = { __typename?: 'Query', stripeAccountInfo: { __typename?: 'StripeAccountInfo', onboard_link?: string | null, login_link?: string | null, is_onboarded: boolean } };

export type StripeBillingPortalUrlQueryVariables = Types.Exact<{
  code: Types.Scalars['String']['input'];
}>;


export type StripeBillingPortalUrlQuery = { __typename?: 'Query', stripeBillingPortalUrl: string };

export type StripeConnectedAccountPortalUrlQueryVariables = Types.Exact<{
  outfitterId: Types.Scalars['ID']['input'];
}>;


export type StripeConnectedAccountPortalUrlQuery = { __typename?: 'Query', stripeConnectedAccountPortalUrl: string };

export type StripeSubscriptionPortalUrlQueryVariables = Types.Exact<{
  outfitterId: Types.Scalars['ID']['input'];
}>;


export type StripeSubscriptionPortalUrlQuery = { __typename?: 'Query', stripeSubscriptionPortalUrl: string };

export type CreateSetupIntentMutationVariables = Types.Exact<{
  userId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
}>;


export type CreateSetupIntentMutation = { __typename?: 'Mutation', createSetupIntent: { __typename?: 'StripeSetupIntent', id: string, client_secret: string } };

export type CreateGroupPayMemberSetupIntentMutationVariables = Types.Exact<{
  memberId: Types.Scalars['ID']['input'];
}>;


export type CreateGroupPayMemberSetupIntentMutation = { __typename?: 'Mutation', createGroupPayMemberSetupIntent: { __typename?: 'StripeSetupIntent', id: string, client_secret: string } };

export type DeletePaymentMethodMutationVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
  userId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
  groupPayMemberId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
}>;


export type DeletePaymentMethodMutation = { __typename?: 'Mutation', deletePaymentMethod: Array<{ __typename?: 'PaymentBlock', id: string, title: string, subtitle?: string | null, subtitle2?: string | null, payment_gateway: Types.PaymentGateway, type?: Types.PaymentBlockType | null, brand?: string | null, is_default?: boolean | null }> };

export type ProcessQuickPayPaymentMutationVariables = Types.Exact<{
  paymentId: Types.Scalars['ID']['input'];
  paymentMethodId: Types.Scalars['String']['input'];
  invitationId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
}>;


export type ProcessQuickPayPaymentMutation = { __typename?: 'Mutation', processQuickPayPayment: { __typename?: 'Payment', id: string, date: number, value: number, status: Types.PaymentStatus, description?: string | null, mb_amount: number, outfitter_amount: number, intent_id?: string | null, booking?: { __typename?: 'Booking', id: string } | null, outfitter: { __typename?: 'Outfitter', id: string, name: string }, user?: { __typename?: 'User', id: string, email: string, first_name?: string | null, last_name?: string | null, phone?: string | null } | null, group_pay_member?: { __typename?: 'GroupPayMember', id: string, email: string, name: string, phone?: string | null } | null, customer?: { __typename?: 'PaymentCustomer', name?: string | null, email?: string | null, phone?: string | null } | null } };

export type CreateSetupIntentOnBehalfOfMutationVariables = Types.Exact<{
  data: Types.CreateSetupIntentOnBehalfOfInput;
}>;


export type CreateSetupIntentOnBehalfOfMutation = { __typename?: 'Mutation', createSetupIntentOnBehalfOf: { __typename?: 'StripeSetupIntent', id: string, client_secret: string } };

export const PaymentBlockFieldsFragmentDoc = gql`
    fragment PaymentBlockFields on PaymentBlock {
  id
  title
  subtitle
  subtitle2
  payment_gateway
  type
  brand
  is_default
}
    `;
export const StripeSetupIntentFieldsFragmentDoc = gql`
    fragment StripeSetupIntentFields on StripeSetupIntent {
  id
  client_secret
}
    `;
export const StripePaymentIntentFieldsFragmentDoc = gql`
    fragment StripePaymentIntentFields on StripePaymentIntent {
  id
  client_secret
}
    `;
export const SportsmanPaymentBlocksDocument = gql`
    query sportsmanPaymentBlocks($sportsmanId: ID!) {
  sportsmanPaymentBlocks(sportsmanId: $sportsmanId) {
    ...PaymentBlockFields
  }
}
    ${PaymentBlockFieldsFragmentDoc}`;

/**
 * __useSportsmanPaymentBlocksQuery__
 *
 * To run a query within a React component, call `useSportsmanPaymentBlocksQuery` and pass it any options that fit your needs.
 * When your component renders, `useSportsmanPaymentBlocksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSportsmanPaymentBlocksQuery({
 *   variables: {
 *      sportsmanId: // value for 'sportsmanId'
 *   },
 * });
 */
export function useSportsmanPaymentBlocksQuery(baseOptions: Apollo.QueryHookOptions<SportsmanPaymentBlocksQuery, SportsmanPaymentBlocksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SportsmanPaymentBlocksQuery, SportsmanPaymentBlocksQueryVariables>(SportsmanPaymentBlocksDocument, options);
      }
export function useSportsmanPaymentBlocksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SportsmanPaymentBlocksQuery, SportsmanPaymentBlocksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SportsmanPaymentBlocksQuery, SportsmanPaymentBlocksQueryVariables>(SportsmanPaymentBlocksDocument, options);
        }
export type SportsmanPaymentBlocksQueryHookResult = ReturnType<typeof useSportsmanPaymentBlocksQuery>;
export type SportsmanPaymentBlocksLazyQueryHookResult = ReturnType<typeof useSportsmanPaymentBlocksLazyQuery>;
export type SportsmanPaymentBlocksQueryResult = Apollo.QueryResult<SportsmanPaymentBlocksQuery, SportsmanPaymentBlocksQueryVariables>;
export const GroupPayMemberPaymentBlocksDocument = gql`
    query groupPayMemberPaymentBlocks($groupPayMemberId: ID!) {
  groupPayMemberPaymentBlocks(groupPayMemberId: $groupPayMemberId) {
    ...PaymentBlockFields
  }
}
    ${PaymentBlockFieldsFragmentDoc}`;

/**
 * __useGroupPayMemberPaymentBlocksQuery__
 *
 * To run a query within a React component, call `useGroupPayMemberPaymentBlocksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupPayMemberPaymentBlocksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupPayMemberPaymentBlocksQuery({
 *   variables: {
 *      groupPayMemberId: // value for 'groupPayMemberId'
 *   },
 * });
 */
export function useGroupPayMemberPaymentBlocksQuery(baseOptions: Apollo.QueryHookOptions<GroupPayMemberPaymentBlocksQuery, GroupPayMemberPaymentBlocksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GroupPayMemberPaymentBlocksQuery, GroupPayMemberPaymentBlocksQueryVariables>(GroupPayMemberPaymentBlocksDocument, options);
      }
export function useGroupPayMemberPaymentBlocksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupPayMemberPaymentBlocksQuery, GroupPayMemberPaymentBlocksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GroupPayMemberPaymentBlocksQuery, GroupPayMemberPaymentBlocksQueryVariables>(GroupPayMemberPaymentBlocksDocument, options);
        }
export type GroupPayMemberPaymentBlocksQueryHookResult = ReturnType<typeof useGroupPayMemberPaymentBlocksQuery>;
export type GroupPayMemberPaymentBlocksLazyQueryHookResult = ReturnType<typeof useGroupPayMemberPaymentBlocksLazyQuery>;
export type GroupPayMemberPaymentBlocksQueryResult = Apollo.QueryResult<GroupPayMemberPaymentBlocksQuery, GroupPayMemberPaymentBlocksQueryVariables>;
export const StripeAccountInfoDocument = gql`
    query stripeAccountInfo($onboardLinkUrls: AccountOnboardLinkInput!) {
  stripeAccountInfo(onboardLinkUrls: $onboardLinkUrls) {
    onboard_link
    login_link
    is_onboarded
  }
}
    `;

/**
 * __useStripeAccountInfoQuery__
 *
 * To run a query within a React component, call `useStripeAccountInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useStripeAccountInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStripeAccountInfoQuery({
 *   variables: {
 *      onboardLinkUrls: // value for 'onboardLinkUrls'
 *   },
 * });
 */
export function useStripeAccountInfoQuery(baseOptions: Apollo.QueryHookOptions<StripeAccountInfoQuery, StripeAccountInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StripeAccountInfoQuery, StripeAccountInfoQueryVariables>(StripeAccountInfoDocument, options);
      }
export function useStripeAccountInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StripeAccountInfoQuery, StripeAccountInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StripeAccountInfoQuery, StripeAccountInfoQueryVariables>(StripeAccountInfoDocument, options);
        }
export type StripeAccountInfoQueryHookResult = ReturnType<typeof useStripeAccountInfoQuery>;
export type StripeAccountInfoLazyQueryHookResult = ReturnType<typeof useStripeAccountInfoLazyQuery>;
export type StripeAccountInfoQueryResult = Apollo.QueryResult<StripeAccountInfoQuery, StripeAccountInfoQueryVariables>;
export const StripeBillingPortalUrlDocument = gql`
    query stripeBillingPortalUrl($code: String!) {
  stripeBillingPortalUrl(code: $code)
}
    `;

/**
 * __useStripeBillingPortalUrlQuery__
 *
 * To run a query within a React component, call `useStripeBillingPortalUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useStripeBillingPortalUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStripeBillingPortalUrlQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useStripeBillingPortalUrlQuery(baseOptions: Apollo.QueryHookOptions<StripeBillingPortalUrlQuery, StripeBillingPortalUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StripeBillingPortalUrlQuery, StripeBillingPortalUrlQueryVariables>(StripeBillingPortalUrlDocument, options);
      }
export function useStripeBillingPortalUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StripeBillingPortalUrlQuery, StripeBillingPortalUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StripeBillingPortalUrlQuery, StripeBillingPortalUrlQueryVariables>(StripeBillingPortalUrlDocument, options);
        }
export type StripeBillingPortalUrlQueryHookResult = ReturnType<typeof useStripeBillingPortalUrlQuery>;
export type StripeBillingPortalUrlLazyQueryHookResult = ReturnType<typeof useStripeBillingPortalUrlLazyQuery>;
export type StripeBillingPortalUrlQueryResult = Apollo.QueryResult<StripeBillingPortalUrlQuery, StripeBillingPortalUrlQueryVariables>;
export const StripeConnectedAccountPortalUrlDocument = gql`
    query stripeConnectedAccountPortalUrl($outfitterId: ID!) {
  stripeConnectedAccountPortalUrl(outfitterId: $outfitterId)
}
    `;

/**
 * __useStripeConnectedAccountPortalUrlQuery__
 *
 * To run a query within a React component, call `useStripeConnectedAccountPortalUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useStripeConnectedAccountPortalUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStripeConnectedAccountPortalUrlQuery({
 *   variables: {
 *      outfitterId: // value for 'outfitterId'
 *   },
 * });
 */
export function useStripeConnectedAccountPortalUrlQuery(baseOptions: Apollo.QueryHookOptions<StripeConnectedAccountPortalUrlQuery, StripeConnectedAccountPortalUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StripeConnectedAccountPortalUrlQuery, StripeConnectedAccountPortalUrlQueryVariables>(StripeConnectedAccountPortalUrlDocument, options);
      }
export function useStripeConnectedAccountPortalUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StripeConnectedAccountPortalUrlQuery, StripeConnectedAccountPortalUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StripeConnectedAccountPortalUrlQuery, StripeConnectedAccountPortalUrlQueryVariables>(StripeConnectedAccountPortalUrlDocument, options);
        }
export type StripeConnectedAccountPortalUrlQueryHookResult = ReturnType<typeof useStripeConnectedAccountPortalUrlQuery>;
export type StripeConnectedAccountPortalUrlLazyQueryHookResult = ReturnType<typeof useStripeConnectedAccountPortalUrlLazyQuery>;
export type StripeConnectedAccountPortalUrlQueryResult = Apollo.QueryResult<StripeConnectedAccountPortalUrlQuery, StripeConnectedAccountPortalUrlQueryVariables>;
export const StripeSubscriptionPortalUrlDocument = gql`
    query stripeSubscriptionPortalUrl($outfitterId: ID!) {
  stripeSubscriptionPortalUrl(outfitterId: $outfitterId)
}
    `;

/**
 * __useStripeSubscriptionPortalUrlQuery__
 *
 * To run a query within a React component, call `useStripeSubscriptionPortalUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useStripeSubscriptionPortalUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStripeSubscriptionPortalUrlQuery({
 *   variables: {
 *      outfitterId: // value for 'outfitterId'
 *   },
 * });
 */
export function useStripeSubscriptionPortalUrlQuery(baseOptions: Apollo.QueryHookOptions<StripeSubscriptionPortalUrlQuery, StripeSubscriptionPortalUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StripeSubscriptionPortalUrlQuery, StripeSubscriptionPortalUrlQueryVariables>(StripeSubscriptionPortalUrlDocument, options);
      }
export function useStripeSubscriptionPortalUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StripeSubscriptionPortalUrlQuery, StripeSubscriptionPortalUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StripeSubscriptionPortalUrlQuery, StripeSubscriptionPortalUrlQueryVariables>(StripeSubscriptionPortalUrlDocument, options);
        }
export type StripeSubscriptionPortalUrlQueryHookResult = ReturnType<typeof useStripeSubscriptionPortalUrlQuery>;
export type StripeSubscriptionPortalUrlLazyQueryHookResult = ReturnType<typeof useStripeSubscriptionPortalUrlLazyQuery>;
export type StripeSubscriptionPortalUrlQueryResult = Apollo.QueryResult<StripeSubscriptionPortalUrlQuery, StripeSubscriptionPortalUrlQueryVariables>;
export const CreateSetupIntentDocument = gql`
    mutation createSetupIntent($userId: ID) {
  createSetupIntent(userId: $userId) {
    ...StripeSetupIntentFields
  }
}
    ${StripeSetupIntentFieldsFragmentDoc}`;
export type CreateSetupIntentMutationFn = Apollo.MutationFunction<CreateSetupIntentMutation, CreateSetupIntentMutationVariables>;

/**
 * __useCreateSetupIntentMutation__
 *
 * To run a mutation, you first call `useCreateSetupIntentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSetupIntentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSetupIntentMutation, { data, loading, error }] = useCreateSetupIntentMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useCreateSetupIntentMutation(baseOptions?: Apollo.MutationHookOptions<CreateSetupIntentMutation, CreateSetupIntentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSetupIntentMutation, CreateSetupIntentMutationVariables>(CreateSetupIntentDocument, options);
      }
export type CreateSetupIntentMutationHookResult = ReturnType<typeof useCreateSetupIntentMutation>;
export type CreateSetupIntentMutationResult = Apollo.MutationResult<CreateSetupIntentMutation>;
export type CreateSetupIntentMutationOptions = Apollo.BaseMutationOptions<CreateSetupIntentMutation, CreateSetupIntentMutationVariables>;
export const CreateGroupPayMemberSetupIntentDocument = gql`
    mutation createGroupPayMemberSetupIntent($memberId: ID!) {
  createGroupPayMemberSetupIntent(memberId: $memberId) {
    ...StripeSetupIntentFields
  }
}
    ${StripeSetupIntentFieldsFragmentDoc}`;
export type CreateGroupPayMemberSetupIntentMutationFn = Apollo.MutationFunction<CreateGroupPayMemberSetupIntentMutation, CreateGroupPayMemberSetupIntentMutationVariables>;

/**
 * __useCreateGroupPayMemberSetupIntentMutation__
 *
 * To run a mutation, you first call `useCreateGroupPayMemberSetupIntentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGroupPayMemberSetupIntentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGroupPayMemberSetupIntentMutation, { data, loading, error }] = useCreateGroupPayMemberSetupIntentMutation({
 *   variables: {
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useCreateGroupPayMemberSetupIntentMutation(baseOptions?: Apollo.MutationHookOptions<CreateGroupPayMemberSetupIntentMutation, CreateGroupPayMemberSetupIntentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGroupPayMemberSetupIntentMutation, CreateGroupPayMemberSetupIntentMutationVariables>(CreateGroupPayMemberSetupIntentDocument, options);
      }
export type CreateGroupPayMemberSetupIntentMutationHookResult = ReturnType<typeof useCreateGroupPayMemberSetupIntentMutation>;
export type CreateGroupPayMemberSetupIntentMutationResult = Apollo.MutationResult<CreateGroupPayMemberSetupIntentMutation>;
export type CreateGroupPayMemberSetupIntentMutationOptions = Apollo.BaseMutationOptions<CreateGroupPayMemberSetupIntentMutation, CreateGroupPayMemberSetupIntentMutationVariables>;
export const DeletePaymentMethodDocument = gql`
    mutation deletePaymentMethod($id: String!, $userId: ID, $groupPayMemberId: ID) {
  deletePaymentMethod(
    id: $id
    userId: $userId
    groupPayMemberId: $groupPayMemberId
  ) {
    ...PaymentBlockFields
  }
}
    ${PaymentBlockFieldsFragmentDoc}`;
export type DeletePaymentMethodMutationFn = Apollo.MutationFunction<DeletePaymentMethodMutation, DeletePaymentMethodMutationVariables>;

/**
 * __useDeletePaymentMethodMutation__
 *
 * To run a mutation, you first call `useDeletePaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePaymentMethodMutation, { data, loading, error }] = useDeletePaymentMethodMutation({
 *   variables: {
 *      id: // value for 'id'
 *      userId: // value for 'userId'
 *      groupPayMemberId: // value for 'groupPayMemberId'
 *   },
 * });
 */
export function useDeletePaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<DeletePaymentMethodMutation, DeletePaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePaymentMethodMutation, DeletePaymentMethodMutationVariables>(DeletePaymentMethodDocument, options);
      }
export type DeletePaymentMethodMutationHookResult = ReturnType<typeof useDeletePaymentMethodMutation>;
export type DeletePaymentMethodMutationResult = Apollo.MutationResult<DeletePaymentMethodMutation>;
export type DeletePaymentMethodMutationOptions = Apollo.BaseMutationOptions<DeletePaymentMethodMutation, DeletePaymentMethodMutationVariables>;
export const ProcessQuickPayPaymentDocument = gql`
    mutation processQuickPayPayment($paymentId: ID!, $paymentMethodId: String!, $invitationId: ID) {
  processQuickPayPayment(
    paymentId: $paymentId
    paymentMethodId: $paymentMethodId
    invitationId: $invitationId
  ) {
    ...PaymentFields
  }
}
    ${PaymentFieldsFragmentDoc}`;
export type ProcessQuickPayPaymentMutationFn = Apollo.MutationFunction<ProcessQuickPayPaymentMutation, ProcessQuickPayPaymentMutationVariables>;

/**
 * __useProcessQuickPayPaymentMutation__
 *
 * To run a mutation, you first call `useProcessQuickPayPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessQuickPayPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processQuickPayPaymentMutation, { data, loading, error }] = useProcessQuickPayPaymentMutation({
 *   variables: {
 *      paymentId: // value for 'paymentId'
 *      paymentMethodId: // value for 'paymentMethodId'
 *      invitationId: // value for 'invitationId'
 *   },
 * });
 */
export function useProcessQuickPayPaymentMutation(baseOptions?: Apollo.MutationHookOptions<ProcessQuickPayPaymentMutation, ProcessQuickPayPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessQuickPayPaymentMutation, ProcessQuickPayPaymentMutationVariables>(ProcessQuickPayPaymentDocument, options);
      }
export type ProcessQuickPayPaymentMutationHookResult = ReturnType<typeof useProcessQuickPayPaymentMutation>;
export type ProcessQuickPayPaymentMutationResult = Apollo.MutationResult<ProcessQuickPayPaymentMutation>;
export type ProcessQuickPayPaymentMutationOptions = Apollo.BaseMutationOptions<ProcessQuickPayPaymentMutation, ProcessQuickPayPaymentMutationVariables>;
export const CreateSetupIntentOnBehalfOfDocument = gql`
    mutation createSetupIntentOnBehalfOf($data: CreateSetupIntentOnBehalfOfInput!) {
  createSetupIntentOnBehalfOf(data: $data) {
    ...StripeSetupIntentFields
  }
}
    ${StripeSetupIntentFieldsFragmentDoc}`;
export type CreateSetupIntentOnBehalfOfMutationFn = Apollo.MutationFunction<CreateSetupIntentOnBehalfOfMutation, CreateSetupIntentOnBehalfOfMutationVariables>;

/**
 * __useCreateSetupIntentOnBehalfOfMutation__
 *
 * To run a mutation, you first call `useCreateSetupIntentOnBehalfOfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSetupIntentOnBehalfOfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSetupIntentOnBehalfOfMutation, { data, loading, error }] = useCreateSetupIntentOnBehalfOfMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateSetupIntentOnBehalfOfMutation(baseOptions?: Apollo.MutationHookOptions<CreateSetupIntentOnBehalfOfMutation, CreateSetupIntentOnBehalfOfMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSetupIntentOnBehalfOfMutation, CreateSetupIntentOnBehalfOfMutationVariables>(CreateSetupIntentOnBehalfOfDocument, options);
      }
export type CreateSetupIntentOnBehalfOfMutationHookResult = ReturnType<typeof useCreateSetupIntentOnBehalfOfMutation>;
export type CreateSetupIntentOnBehalfOfMutationResult = Apollo.MutationResult<CreateSetupIntentOnBehalfOfMutation>;
export type CreateSetupIntentOnBehalfOfMutationOptions = Apollo.BaseMutationOptions<CreateSetupIntentOnBehalfOfMutation, CreateSetupIntentOnBehalfOfMutationVariables>;